import {
  faAngleRight,
  faBox,
  faChevronRight,
  faClipboard,
  faHeart,
  faList,
  faUser,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import P from "components/P";
import Container from "layouts/container/Container";
import FlexChild from "layouts/flex/FlexChild";
import HorizontalFlex from "layouts/flex/HorizontalFlex";
import VerticalFlex from "layouts/flex/VerticalFlex";
import style from "./MyPageInfo.module.css";
import listData from "InitialData/accounts/listData.json";
import { useContext, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import NiceModal from "@ebay/nice-modal-react";
import CardList from "layouts/wrapper/CardList";
import { useTranslation } from "react-i18next";
import noWishList from "resources/img/icons/noWishList.png";
import { Link, NavLink, useNavigate } from "react-router-dom";
import Inline from "layouts/container/Inline";
import { BrowserDetectContext } from "providers/BrowserEventProvider";
import Center from "layouts/wrapper/Center";
import AccordionWrapper from "components/accordion/AccordionWrapper";
import AccordionText from "components/accordion/AccordionText";
import { requester, storeRequester } from "App";
import coupon from "resources/img/icons/coupon.png";
import point from "resources/img/icons/point.png";
import menu from "resources/img/icons/footer/menu.svg";
import {
  addCommas,
  getCurrentLanguageCode,
  removeLocalStorage,
} from "shared/utils/Utils";
import { AuthContext } from "providers/AuthProvider";
import CustomIcon from "components/icons/CustomIcon";
import BannerSwiper from "routes/front/main/BannerSwiper";
import slide2 from "resources/img/main/banner/mainBanner_1.png";
import slide3 from "resources/img/main/banner/mainBanner_2.png";
import WishCardList from "./wishList/WishCardList";
import Loader from "components/inputs/image/Loader";
import OrderListLayout from "./order/TrackOrderLayout";
import Dummy from "components/Dummy";


function MyPageInfo(props) {
  const [isOrderList, setOrderList] = useState([]);
  const [mounted, setMounted] = useState(false);
  const [lastThreeOrder, setLastThreeOrder] = useState([]);
  const { isMobile } = useContext(BrowserDetectContext);
  const { userName, userInfo } = useContext(AuthContext);
  const [isUserInfo, setUserInfo] = useState();
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [isLoading, setIsLoading] = useState(true);



  const fetchOrders = async (limit, offset) => {
    try {
      const { orders } = await storeRequester.getCustomerOrders({
        expand: "shipping_address",
        limit: limit,
        offset: offset,
      });

      if (orders) {
        setOrderList(orders);
      }
    } catch (error) {

    }
  };

  useEffect(() => {
    if (userInfo) {
      setUserInfo(userInfo)
    }
  }, [userInfo])
  useEffect(() => {
    fetchOrders(3, 0);
  }, [isMobile]);

  useEffect(() => {
    if (isOrderList && Array.isArray(isOrderList)) {
      const sortedOrders = [...isOrderList].sort(
        (a, b) => new Date(b.createDate) - new Date(a.createDate)
      );

      const topThreeOrders = sortedOrders.slice(0, 3);

      setLastThreeOrder(topThreeOrders);
      setIsLoading(false);
    }
  }, [isOrderList]);

  const formatDate = (dateString) => {
    const days = ["일", "월", "화", "수", "목", "금", "토"];
    const date = new Date(dateString);

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    const dayOfWeek = days[date.getDay()];

    return `${year}.${month}.${day}(${dayOfWeek})`;
  };
  const listArray = [
    {
      id: 1,
      title: "주문배송 정보",
      contents: [
        {
          content: "주문배송 조회",
          to: "/mypage/trackOrder",
          icon: faClipboard
        }
      ]
    },
    {
      id: 2,
      title: "배송지 관리",
      contents: [
        {
          content: "배송지 등록 및 관리",
          to: "/mypage/shippingInfo",
          icon: faBox
        }
      ]
    },
    {
      id: 3,
      title: "계정관리",
      contents: [
        {
          content: "비밀번호 변경",
          type: "modal",
          modalName: "customerPasswordChange",
          isForced: false,
          icon: faUser
        },
        {
          content: "로그아웃",
          to: "/mypage/logout",
          icon: faUser
        }
      ]
    },
    {
      id: 4,
      title: "위시리스트",
      contents: [
        {
          content: "위시리스트",
          to: "/wishlist",
          icon: faHeart
        }
      ]
    }
  ]
  const ListRow = (props) => {
    const { id, icon, title, contents } = props;
    const backgroundColor = id % 2 === 0 ? "white" : "rgba(244,247,255,1)";

    const handleClick = (row) => {
      if (row.type === "modal") {
        NiceModal.show(row.modalName, { isForced: row.isForced });  // row.isForced 전달
      } else if (row.to) {
        navigate(row.to);
      }
    };

    return (
      <Container backgroundColor={backgroundColor}>
        <div style={{ padding: "20px 15px" }}>
          <P size={18} weight={700} padding={"10px 0"}>{title}</P>
          <Inline padding={"0 0 0 5px"}>
            <FontAwesomeIcon icon={icon} color={"#ddd"} size={"lg"} />
            {
              contents.map((row, index) => {
                return (
                  <Center key={index} width={"100%"} padding={"0 0 15px 0"}>
                    <Inline textAlign={"left"}>
                      <FontAwesomeIcon size={"lg"} icon={row.icon} color={"#aaa"} />
                      <Dummy width={"10px"} />
                      <P
                        cursor
                        onClick={() => handleClick(row)}
                        weight={600}
                        size={16}
                      >
                        {row.content}
                      </P>
                    </Inline>
                  </Center>
                );
              })
            }
          </Inline>
        </div>
      </Container>
    );
  }
  const onTrackOrderDetailClick = (data) => {
    navigate("/mypage/trackOrder/detail", { state: { data: data } })
  }

  return (
    <Container>
      <Container backgroundColor={isMobile ? "" : "white"} maxWidth={1000}>
        {isMobile ? (
          <VerticalFlex>
            <FlexChild>
              <VerticalFlex gap={25}>
                <FlexChild
                  padding={"20px 15px 15px 15px"}
                  backgroundColor={" var(--main-color)"}
                >
                  <div className={style.wrap}>
                    <VerticalFlex gap={30}>
                      <FlexChild>
                        <HorizontalFlex gap={20}>
                          <FlexChild width={"max-content"} >
                            <VerticalFlex gap={10}>
                              <FlexChild alignItems={"flex-start"}>
                                <P color={"white"}>MY PAGE</P>
                              </FlexChild>
                              <FlexChild>
                                <P size={20} color={"white"} weight={700}>{isUserInfo?.first_name}님 {isUserInfo?.groups[0]?.name}</P>
                              </FlexChild>
                            </VerticalFlex>
                          </FlexChild>
                          <FlexChild maxWidth={"max-content"}>
                            {userName ? (
                              null
                            ) : (
                              <Center width={"100%"} textAlign={"left"}>
                                <div className={style.userWelcome}>
                                  <P size={"16pt"} weight={"bold"}>
                                    {" "}
                                    {t("pleaseLogin")}
                                  </P>
                                </div>
                              </Center>
                            )}
                          </FlexChild>
                        </HorizontalFlex>
                      </FlexChild>
                      <FlexChild>
                        <div className={style.mypageBar}>
                          <HorizontalFlex>
                            <FlexChild justifyContent={"flex-start"}>
                              <P size={18} color={"black"}>포인트</P>
                            </FlexChild>
                            <FlexChild justifyContent={"flex-end"}>
                              <P weight={700} size={20} color={"var(--main-color)"}>{addCommas(isUserInfo?.point)} 포인트</P>
                            </FlexChild>
                          </HorizontalFlex>
                        </div>
                      </FlexChild>
                    </VerticalFlex>
                  </div>
                </FlexChild>

                <FlexChild>
                  <VerticalFlex gap={10}>
                    <FlexChild alignItems={"flex-start"} padding={"10px 15px"}>
                      <Inline>
                        <P size={18} weight={"bold"}>{t("orderHistory")} </P>
                        <P size={14} weight={500} color={"#999"}>{t("최근 3건 표시")}</P>
                      </Inline>
                    </FlexChild>
                    {isLoading ? (
                      <Loader />
                    ) : (
                      <>
                        {lastThreeOrder &&
                          lastThreeOrder.length > 0 &&
                          lastThreeOrder.map((data, index) => (
                            <FlexChild padding={"0px 15px"} key={index}>
                              <div className={style.horizontalCardWrap} onClick={() => onTrackOrderDetailClick(data)}>
                                <VerticalFlex gap={5}>
                                  <FlexChild alignItems={"flex-start"}>
                                    <P weight={500} color={"#999"}>
                                      {formatDate(data.created_at)}
                                    </P>

                                  </FlexChild>
                                  <FlexChild padding={"0 0 5px 0 "}>
                                    <div style={{ width: "100%", height: "1px", backgroundColor: "#eee" }} />
                                  </FlexChild>
                                  <FlexChild>
                                    <HorizontalFlex gap={15}>
                                      <FlexChild width={"max-content"}>
                                        {data.items &&
                                          data.items?.length > 0 && (
                                            <img
                                              width={"90px"}
                                              src={data.items[0].thumbnail}
                                            />
                                          )}
                                      </FlexChild>
                                      <FlexChild>
                                        <VerticalFlex flexStart gap={5}>
                                          <FlexChild>
                                            <HorizontalFlex>
                                              <FlexChild>
                                                <P
                                                  size={16}
                                                  weight={"bold"}
                                                  color={"var(--main-color)"}
                                                >
                                                  {t(data.status)}
                                                </P>
                                              </FlexChild>
                                              <FlexChild justifyContent={"flex-end"}>
                                                <FontAwesomeIcon icon={faAngleRight} color={"#999"} />
                                              </FlexChild>
                                            </HorizontalFlex>
                                          </FlexChild>
                                          <FlexChild>
                                            {data.items &&
                                              data.items.length > 0 && (
                                                <P size={16}>{data.items[0].title}</P>
                                              )}
                                          </FlexChild>
                                          <FlexChild>
                                            <HorizontalFlex alignItems={"flex-end"}>
                                              <FlexChild>
                                                <Inline>
                                                  <P size={16}>{data.items && data.items[0]?.description}</P>
                                                  {data.items &&
                                                    data.items?.length > 1 && (
                                                      <P size={16}> 외 {(data.items?.length) - 1}개</P>
                                                    )}
                                                </Inline>
                                              </FlexChild>
                                              <FlexChild
                                                alignItems={"flex-end"}
                                                justifyContent={"flex-end"}
                                              >
                                                <P
                                                  weight={"bold"}
                                                  color={"var(--main-color)"}
                                                  size={16}
                                                >
                                                  &#8361;{addCommas(data.total)}
                                                </P>
                                              </FlexChild>
                                            </HorizontalFlex>
                                          </FlexChild>
                                        </VerticalFlex>
                                      </FlexChild>
                                    </HorizontalFlex>
                                  </FlexChild>
                                </VerticalFlex>
                              </div>
                            </FlexChild>
                          ))}
                      </>
                    )}
                    <Dummy height={"20px"} />
                    {
                      listArray.map((r, index) => {
                        return (
                          <FlexChild>
                            <ListRow
                              id={r.id}
                              title={r.title}
                              contents={r.contents}
                            />
                          </FlexChild>
                        );
                      })
                    }
                  </VerticalFlex>
                </FlexChild>
              </VerticalFlex>
            </FlexChild>
          </VerticalFlex>
        ) : (
          <OrderListLayout />
        )}
      </Container>
    </Container>
  );
}

export default MyPageInfo;
